/** 权限不足提示防抖，避免同一次操作重复弹多层 toast。 */
let lastForbiddenToastAt = 0;
let lastForbiddenToastMessage = "";

const FORBIDDEN_TOAST_DEBOUNCE_MS = 1600;

/** 展示无权限提示；短时间内相同文案只提示一次。 */
export function notifyForbiddenPermission(message: string): void {
  if (typeof window === "undefined") {
    return;
  }
  const content = message.trim();
  if (!content) {
    return;
  }
  const now = Date.now();
  if (
    content === lastForbiddenToastMessage &&
    now - lastForbiddenToastAt < FORBIDDEN_TOAST_DEBOUNCE_MS
  ) {
    return;
  }
  lastForbiddenToastAt = now;
  lastForbiddenToastMessage = content;
  void import("@arco-design/web-react").then(({ Message }) => {
    Message.warning({ content, duration: 4000 });
  });
}

/** 测试用：重置防抖状态。 */
export function resetForbiddenPermissionToastState(): void {
  lastForbiddenToastAt = 0;
  lastForbiddenToastMessage = "";
}
